// extracted by mini-css-extract-plugin
export var headerCell = "_4s-1";
export var loadingStateCell = "_4s-4";
export var rowWrapper = "_4s-3";
export var standaloneTable = "_4s-5";
export var table = "_4s-0";
export var white = "_4s-2";